import { render, staticRenderFns } from "./FiFeeItem.vue?vue&type=template&id=80effbb6&scoped=true&lang=pug&"
import script from "./FiFeeItem.vue?vue&type=script&lang=js&"
export * from "./FiFeeItem.vue?vue&type=script&lang=js&"
import style0 from "./FiFeeItem.vue?vue&type=style&index=0&id=80effbb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80effbb6",
  null
  
)

/* custom blocks */
import block0 from "./FiFeeItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports